import { Link } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { DOMAINS, useDomain } from "../../utils/domain";
import { getLocalizedUrl } from "../../utils/url";
/** logos has 3 versions and are divided into 2 directories:
 * - with padding, used in header/job listing
 * - without padding, used in footer
 * - group white version (with and without padding), used in footer, mobile nav menu
 *
 * **name pattern: img/logos/svg/(no-padding|padding)-locale.svg**
 */
export var Logo = function Logo(param) {
  var _param_variant = param.variant,
    variant = _param_variant === void 0 ? "default" : _param_variant,
    _param_size = param.size,
    size = _param_size === void 0 ? "regular" : _param_size,
    _param_hasPadding = param.hasPadding,
    hasPadding = _param_hasPadding === void 0 ? true : _param_hasPadding;
  var domain = useDomain();
  var t = useTranslation().t;
  var _useTranslation = useTranslation(),
    _useTranslation_i18n = _useTranslation.i18n,
    locale = _useTranslation_i18n.language;
  var groupDomainId = "paraplegie_ch";
  var logoBaseSvg = variant === "default" || variant === "default-white" ? DOMAINS[groupDomainId].logoPathBase : domain.logoPathBase;
  var logoPath = "/img/logos/svg/".concat(!hasPadding ? "no-padding" : "padding", "/").concat(logoBaseSvg, "-").concat(locale).concat(variant === "default-white" ? "-white" : "", ".svg");
  var homeLink = getLocalizedUrl({
    to: "/",
    locale: locale,
    domain: variant === "default" || variant === "default-white" ? DOMAINS[groupDomainId] : domain
  }).url;
  return /*#__PURE__*/React.createElement(Link, {
    href: homeLink,
    id: "SiteLogo--link",
    title: t(domain.title),
    className: "rounded-1.25"
  }, variant === "compact" ? /*#__PURE__*/React.createElement("div", {
    className: "theme-default text-theme-dark",
    "aria-label": t(domain.title)
  }, /*#__PURE__*/React.createElement(LogoCompactSvg, {
    className: "h-10 w-auto"
  })) : variant === "compact-white" ? /*#__PURE__*/React.createElement("div", {
    className: "text-primary-white",
    "aria-label": t(domain.title)
  }, /*#__PURE__*/React.createElement(LogoCompactSvg, null)) : /*#__PURE__*/React.createElement("img", {
    alt: t(domain.title),
    className: clsx("w-auto max-w-full", {
      "min-h-11 ": size === "small" && hasPadding,
      "h-14": size === "regular" && hasPadding,
      "min-h-10": size === "small" && !hasPadding,
      "min-h-12": size === "regular" && !hasPadding
    }),
    src: logoPath
  }));
};
// Compact logo svg, doesn't include text
// used for elements that needs smoother transitions between colored/white/black logo versions
export var LogoCompactSvg = function LogoCompactSvg(param) {
  var className = param.className;
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    className: className,
    viewBox: "0 0 48 33",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.098 13.959v-9.12h-5.57v9.12H5.476v4.781h9.05v13.435h-4.523V23.22H.954V9.483h9.05V.363h14.618v9.12h11.144c1.53 0 2.462.91 2.462 2.24s-.932 2.24-2.462 2.24H20.098v-.004Zm15.394-9.117c4.75 0 7.645 2.824 7.645 6.95 0 4.127-2.895 6.952-7.645 6.952h-5.535v8.955h-5.338v-8.955h-4.524v13.434H34.48v-8.955h1.753c6.312 0 11.427-5.116 11.427-11.427C47.66 5.484 42.545.369 36.233.369h-4.746c-1.53 0-2.462.91-2.462 2.24 0 1.329.932 2.239 2.462 2.239h4.005v-.006Z"
  }));
};